import { useCallback, useEffect, useState } from "react";
import { fetchTasksBySource } from "../../../services/messagingService";
import { loadCurrentStaffUser } from "../../../utils/currentStaffUser";
import { onWorkItemsChanged } from "../../../utils/workItemsBus";
import { latestTaskBySourceRef } from "../../../components/messaging/sourceTasks";

// Shared with the other places a task can be made from (a chart's signed orders).
export { latestTaskBySourceRef, SourceTaskChip } from "../../../components/messaging/sourceTasks";

/**
 * Rows of the Live Activity tabs (a memory issue, a DB health check) can be
 * assigned as a Messages task. The task points back at its row with
 * internal_tasks.source_kind ("memory_issue", "db_health") + source_ref (the
 * row's id), and the row shows that task.
 */

// The signed-in user (the assigner) and each row's task. Tasks are reloaded
// after assigning and whenever one changes anywhere (e.g. marked done in
// Messages → Tasks). `label` names the tab in console warnings.
export function useSourceTasks(sourceKind, label) {
  const [me, setMe] = useState(null);
  const [taskByRef, setTaskByRef] = useState({});

  useEffect(() => {
    let cancelled = false;
    loadCurrentStaffUser()
      .then((u) => { if (!cancelled) setMe(u); })
      .catch((e) => console.warn(`${label}: could not load the signed-in user`, e));
    return () => { cancelled = true; };
  }, [label]);

  const reloadTasks = useCallback(async () => {
    try {
      const { tasks } = await fetchTasksBySource(sourceKind);
      setTaskByRef(latestTaskBySourceRef(tasks));
    } catch (e) {
      console.warn(`${label}: could not load their tasks`, e);
    }
  }, [sourceKind, label]);
  useEffect(() => { reloadTasks(); }, [reloadTasks]);
  useEffect(() => onWorkItemsChanged(() => reloadTasks()), [reloadTasks]);

  return { me, taskByRef, reloadTasks };
}
